import React from 'react';
import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';
import { SignatureIcon } from 'apps/TenantApp/screens/ItemViewer/FileRenderer/PrepareSignatureFileRenderer/SignatureIcon';

export const useItemRightIcon = (item: useItemHandleFragment$data) => {
  switch (item.__typename) {
    case 'VaultItem':
    case 'FolderItem':
      return <SignatureIcon status={item.signatureEnvelope?.status || null} />;
    default:
      return null;
  }
};
